// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__Kd2KD","LogoText":"Logo_LogoText__1uxqr"};